import EmptyState from '../components/EmptyState';

export default function Qa() {
  return (
    <EmptyState
      title="QA"
      description="Quality assurance scoring, review queues, and audit trails"
    />
  );
}
